import { ClientsService } from '../services/clients/clients.service';
import { OnDestroy, OnInit } from '@angular/core';
import { WsService } from '../services/websocket/WsService';
import { WsConst } from '../globals/WsConst';
import { DashboardDataService } from '../services/dashboard-data.service';
import { DataTable, Message } from 'primeng/primeng';
import { Globals } from '../globals/Globals';
import { isNullOrUndefined, isUndefined } from 'util';
import {
  HttpClient,
  HttpHeaders,
  HttpParams,
  HttpRequest,
} from '@angular/common/http';
import { CookieService } from 'ngx-cookie-service';

export abstract class SuperClass implements OnInit, OnDestroy {
  clientsSubscriber;
  socketSubscriber;
  statisticsSubscriber;

  msgs: Message[] = [];

  reqToLoad = 0;
  reqLoaded = 0;

  constructor(
    private c: ClientsService,
    private w: WsService,
    private d: DashboardDataService,
    private http: HttpClient,
    private cookies: CookieService,
  ) {
    this.clientsSubscriber = c.getClientsSubject().subscribe(data => {
      this.reloadData();
    });

    this.socketSubscriber = w.getSocketSubscriber().subscribe((data: any) => {
      if (
        data.code === this.getWebSocketIdentifier() &&
        data.code === WsConst.STATISTICS
      ) {
        this.reloadData();
      }
    });
  }

  abstract reloadData(): void;

  abstract getWebSocketIdentifier(): string;

  setData(data): void {}

  ngOnInit(): void {
    if (this.getWebSocketIdentifier() === WsConst.STATISTICS) {
      this.statisticsSubscriber = this.d.getDDSubscriber().subscribe(data => {
        this.setData(data);
      });
    }
    this.reloadData();
  }

  ngOnDestroy(): void {
    this.clientsSubscriber.unsubscribe();
    this.socketSubscriber.unsubscribe();
    if (this.getWebSocketIdentifier() === WsConst.STATISTICS) {
      this.statisticsSubscriber.unsubscribe();
    }
  }

  hasEmptyFields(requiredFields) {
    for (let i = 0; i < requiredFields.length; i++) {
      if (
        isNullOrUndefined(requiredFields[i].value) ||
        requiredFields[i].value === '' ||
        requiredFields[i].value.name === ''
      ) {
        this.showMessage(
          'warn',
          'Warning',
          "'" + requiredFields[i].fieldName + "' can't be empty",
        );
        if (!isUndefined(requiredFields[i].id)) {
          document.getElementById(requiredFields[i].id).focus();
        }
        return true;
      }
    }
    return false;
  }

  hasErrorConditions(conditions) {
    for (let i = 0; i < conditions.length; i++) {
      if (conditions[i].condition) {
        this.showMessage('warn', 'Warning', conditions[i].message);
        if (!isUndefined(conditions[i].id)) {
          document.getElementById(conditions[i].id).focus();
        }
        return true;
      }
    }
    return false;
  }

  checkData(data): boolean {
    if (data.result === Globals.RESPONSE_RESULT_SUCCESS) {
      return true;
    }
    if (data.result === Globals.RESPONSE_RESULT_ERROR) {
      this.showMessage('error', 'Error', data.payload);
      return false;
    }
    if (data.result === Globals.RESPONSE_RESULT_UNAUTHORIZED) {
      this.showErrorMessage('Wrong Credentials');
      return false;
    }

    this.unknownErrorMessage();

    return false;
  }

  unknownErrorMessage() {
    this.showMessage('error', 'Error', 'Internal Server Error');
  }

  showErrorMessage(detail) {
    this.showMessage('error', 'Error', detail);
  }

  showSuccessMessage(detail) {
    this.showMessage('success', 'Success', detail);
  }

  showMessage(type, summary, detail) {
    this.msgs = [];
    this.msgs.push({ severity: type, summary: summary, detail: detail });
  }

  /*http wrapper*/
  get(url: string, callback) {
    const request = this.http.get(url, { headers: this.getHeaders() });
    this.subscribeOnHttp(request, callback);
    return request;
  }

  getWithParams(url: string, params: HttpParams, callback) {
    const request = this.http.get(url, {
      headers: this.getHeaders(),
      params: params,
    });
    this.subscribeOnHttp(request, callback);
    return request;
  }

  post(url: string, body: any, callback) {
    const request = this.http.post(url, body, this.getOptions());
    this.subscribeOnHttp(request, callback);
    return request;
  }

  postWithParams(url: string, body: any, params: HttpParams, callback) {
    const request = this.http.post(url, body, {
      headers: this.getHeaders(),
      params: params,
    });
    this.subscribeOnHttp(request, callback);
    return request;
  }

  request(req: any, callback) {
    const request = this.http.request(req);
    this.subscribeOnHttp(request, callback);
    return request;
  }

  getOptions() {
    return {
      crossdomain: true,
      headers: this.getHeaders(),
    };
  }

  getHeaders() {
    let token = Globals.TOKEN;
    if (isUndefined(token)) {
      token = this.cookies.get(Globals.COOKIES_TOKEN);
    }
    let headers = new HttpHeaders();
    headers = headers.set('X-AUTH-TOKEN', token ? token : '');
    headers = headers.set('Cross-Origin', 'true');
    headers = headers.set(
      'CLIENT-ID',
      this.cookies.get(Globals.COOKIES_CLIENT_ID),
    );
    return headers;
  }

  subscribeOnHttp(req, callback) {
    this.reqToLoad++;
    req.subscribe(
      data => {
        this.reqLoaded++;
        if (data.body) {
          data = JSON.parse(data.body);
        }
        if (this.checkData(data)) {
          callback(data);
        }
      },
      error => {
        this.reqLoaded++;
        this.unknownErrorMessage();
      },
    );
  }

  private getPreparedData(exportDataFile:string, tableRows:any, column:number): string{
    let data = Object.values(tableRows);
    let fields = Object.keys(tableRows);
    let str = data[column];

    if(exportDataFile == 'Login history')
     if(fields[column] == 'logoutTime')
       str = tableRows.loginTime;

    if(!str) return ";";

    if(fields[column] == 'loginTime' || fields[column] == 'logoutTime' || fields[column] == 'operationTime')
      str = new Date(str).toString();

    return str.replace(/[\n\r]+/g, '')
            .replace(/\s{2,}/g, ' ')
            .replace(/;/g, ' ')
            .trim() + ';';
  }

  exportToCSV(datatable: DataTable, columns: number[], name: string): void {
    let headerString = '';
    const headers = datatable.el.nativeElement.querySelectorAll(
      '.ui-column-title',
    );
    for (const column of columns) {
      headerString += headers[column - 1].innerText + ';';   }

    const tableRows = datatable.value;
    const rowsString: string[] = [];
    for (let i = 0; i < tableRows.length; i++){
      let rowString = '';
      for (const column of columns)
        rowString += this.getPreparedData(datatable.exportFilename, tableRows[i], column);
      rowsString.push(rowString);
    }

    // const tableRows = datatable.el.nativeElement.querySelectorAll('TR');
    // const rowsString: string[] = [];
    // for (let i = 1; i < tableRows.length; i++) {
    //   let rowString = '';
    //   const tableRow = tableRows[i].querySelectorAll('.ui-cell-data');
    //   for (const column of columns) {
    //     rowString +=
    //       tableRow[column - 1].innerText
    //         .replace(/[\n\r]+/g, '')
    //         .replace(/\s{2,}/g, ' ')
    //         .trim() + ';';
    //   }
    //   rowsString.push(rowString);
    // }

    let csv = headerString + '\n';
    for (const row of rowsString) {
      csv += row + '\n';
    }

    const blob = new Blob(['\uFEFF', csv], { type: 'text/csv' });
    const link = document.createElement('a');
    link.setAttribute('href', window.URL.createObjectURL(blob));
    link.setAttribute('download', name + '.csv');
    document.body.appendChild(link); // Required for FF
    link.click();
  }

  /*http wrapper*/

  /*http*/

  http_getOptInUsers(offset, size, callback) {
    return this.get(Globals.SERVER_ADDR + '/reports/optInUsers/getAll?offset=' + offset + '&size=' + size, callback);
  }

  // L O G I N
  http_login(credentials, callback) {
    return this.post(Globals.SERVER_ADDR + '/login', credentials, callback);
  }

  // C L I E N T S
  http_getAllClients(callback) {
    return this.get(Globals.SERVER_ADDR + '/org/clients/getAll', callback);
  }

  http_addClients(client, callback) {
    return this.post(
      Globals.SERVER_ADDR + '/org/clients/add',
      client,
      callback,
    );
  }

  http_updateClients(client, callback) {
    return this.post(
      Globals.SERVER_ADDR + '/org/clients/update',
      client,
      callback,
    );
  }

  http_deleteClients(client, callback) {
    return this.post(
      Globals.SERVER_ADDR + '/org/clients/delete',
      client,
      callback,
    );
  }

  // D E S I G N E R
  http_getDefTemplateNames(callback) {
    return this.get(
      Globals.SERVER_ADDR + '/cpBuilder/getDefTemplateNames',
      callback,
    );
  }

  http_getTemplateNames(callback) {
    return this.get(Globals.SERVER_ADDR + '/cpBuilder/templateNames', callback);
  }

  http_getTemplateData(e, callback) {
    return this.get(
      Globals.SERVER_ADDR + '/cpBuilder/getById?id=' + e.value.id,
      callback,
    );
  }

  http_createAndGetTemplate(requestBody, callback) {
    return this.post(
      Globals.SERVER_ADDR + '/cpBuilder/createAndGet',
      requestBody,
      callback,
    );
  }


  http_cloneAndGetTemplate(requestBody, callback) {
    return this.post(
      Globals.SERVER_ADDR + '/cpBuilder/cloneTemplate',
      requestBody,
      callback,
    );
  }

  // A C C O U N T S
  http_updateAccounts(account, type, callback) {
    return this.post(
      Globals.SERVER_ADDR + '/accounts/' + type + '/update',
      account,
      callback,
    );
  }

  http_addAccount(account, type, callback) {
    return this.post(
      Globals.SERVER_ADDR + '/accounts/' + type + '/add',
      account,
      callback,
    );
  }

  http_deleteAccount(account, type, callback) {
    return this.post(
      Globals.SERVER_ADDR + '/accounts/' + type + '/delete',
      account,
      callback,
    );
  }

  http_getTimeLimits(type, callback) {
    if (type === 'paypalOptions') {
      return this.get(
        Globals.SERVER_ADDR + '/accounts/' + type + '/getTimeLimits',
        callback,
      );
    } else if (type === 'voucher') {
      return this.get(
        Globals.SERVER_ADDR + '/org/' + type + '/getTimeLimits',
        callback,
      );
    }
  }

  http_getDownloadLimits(type, callback) {
    if (type === 'paypalOptions') {
      return this.get(
        Globals.SERVER_ADDR + '/accounts/' + type + '/getDownloadLimits',
        callback,
      );
    } else if (type === 'voucher') {
      return this.get(
        Globals.SERVER_ADDR + '/org/' + type + '/getDownloadLimits',
        callback,
      );
    }
  }

  http_getSpeedLimits(type, callback) {
    if (type === 'paypalOptions') {
      return this.get(
        Globals.SERVER_ADDR + '/accounts/' + type + '/getSpeedLimits',
        callback,
      );
    } else if (type === 'voucher') {
      return this.get(
        Globals.SERVER_ADDR + '/org/' + type + '/getSpeedLimits',
        callback,
      );
    }
  }

  http_getAllAccounts(type, callback) {
    return this.get(
      Globals.SERVER_ADDR + '/accounts/' + type + '/getAll',
      callback,
    );
  }

  http_getPaypalCurrencies(callback) {
    return this.get(
      Globals.SERVER_ADDR + '/accounts/paypalOptions/getCurrencies',
      callback,
    );
  }

  http_checkEmail(receiver, account, callback) {
    return this.post(
      Globals.SERVER_ADDR + '/accounts/email/checkEmail?receiver=' + receiver,
      account,
      callback,
    );
  }

  http_getSmsApiTypes(callback) {
    return this.get(
      Globals.SERVER_ADDR + '/accounts/sms/getApiTypes',
      callback,
    );
  }

  http_updateElment(requestBody, callback) {
    return this.post(
      Globals.SERVER_ADDR + '/cp/elements/update',
      requestBody,
      callback,
    );
  }

  http_getSummary(callback) {
    return this.get(
      Globals.SERVER_ADDR + '/reports/sessions/getSummary',
      callback,
    );
  }

  http_postSummary(venueGroup, start, end, callback) {
    return this.get(
      Globals.SERVER_ADDR +
        '/reports/sessions/getSummary' +
        '?venueGroup=' +
        venueGroup +
        '&start=' +
        start +
        '&end=' +
        end,
      callback,
    );
  }

  // CP DESIGNER
  http_getPreviewHtml(requestBody, nasid, lang, callback){
    return this.post(
      Globals.SERVER_ADDR + '/cpBuilder/getPreview?nasid=' + nasid + '&lang=' + lang,
      requestBody,
      callback,
    );
  }

  // C A P T I V E   P O R T A L
  http_getAllCp(callback) {
    return this.get(Globals.SERVER_ADDR + '/cp/getAll', callback);
  }

  http_updateCp(cp, callback) {
    return this.post(Globals.SERVER_ADDR + '/cp/update', cp, callback);
  }

  http_createCP(cp, callback) {
    return this.post(Globals.SERVER_ADDR + '/cp/add', cp, callback);
  }

  http_deleteCP(cp, callback) {
    return this.post(Globals.SERVER_ADDR + '/cp/delete', cp, callback);
  }

  // R E G I O N S
  http_getAllRegions(callback) {
    return this.get(Globals.SERVER_ADDR + '/org/regions/getAll', callback);
  }

  http_updateRegion(cp, callback) {
    return this.post(Globals.SERVER_ADDR + '/org/regions/update', cp, callback);
  }

  http_createRegion(cp, callback) {
    return this.post(Globals.SERVER_ADDR + '/org/regions/add', cp, callback);
  }

  http_deleteRegion(cp, callback) {
    return this.post(Globals.SERVER_ADDR + '/org/regions/delete', cp, callback);
  }

  // V O U C H E R S
  http_getAllVouchers(callback) {
    return this.get(Globals.SERVER_ADDR + '/org/voucher/getAll', callback);
  }

  http_updateVoucher(voucher, callback) {
    return this.post(
      Globals.SERVER_ADDR + '/org/voucher/update',
      voucher,
      callback,
    );
  }

  http_createNewVoucher(voucher, callback) {
    return this.post(
      Globals.SERVER_ADDR + '/org/voucher/add',
      voucher,
      callback,
    );
  }

  http_deleteVoucher(voucher, callback) {
    return this.post(
      Globals.SERVER_ADDR + '/org/voucher/delete',
      voucher,
      callback,
    );
  }

  // L O C A T I O N   S E T U P
  http_getAllVenueCodes(callback) {
    return this.get(
      Globals.SERVER_ADDR + '/org/locations/getVenueCodes',
      callback,
    );
  }

  http_getAllLocations(callback) {
    return this.get(Globals.SERVER_ADDR + '/org/locations/getAll', callback);
  }

  http_updateVenue(venue, callback) {
    return this.post(
      Globals.SERVER_ADDR + '/org/locations/update',
      venue,
      callback,
    );
  }

  http_createNewVenue(body, callback) {
    return this.post(
      Globals.SERVER_ADDR + '/org/locations/add',
      body,
      callback,
    );
  }

  http_createVenuesFromCSV(body, callback) {
    return this.post(
      Globals.SERVER_ADDR + '/org/locations/loadFromCSV',
      body,
      callback,
    );
  }

  http_deleteVenue(venue, callback) {
    return this.post(
      Globals.SERVER_ADDR + '/org/locations/delete',
      venue,
      callback,
    );
  }

  // C O U N T R I E S
  http_getAllCountriesList(callback) {
    return this.get(Globals.SERVER_ADDR + '/org/countries/getAll', callback);
  }

  http_deleteCountry(country, callback) {
    return this.post(
      Globals.SERVER_ADDR + '/org/countries/delete',
      country,
      callback,
    );
  }

  http_createNewCountry(country, callback) {
    return this.post(
      Globals.SERVER_ADDR + '/org/countries/add',
      country,
      callback,
    );
  }

  http_updateCountries(country, callback) {
    return this.post(
      Globals.SERVER_ADDR + '/org/countries/update',
      country,
      callback,
    );
  }

  // A N A L Y T I C S   U S E R S
  http_getAllAnalyticUsers(callback) {
    return this.get(Globals.SERVER_ADDR + '/org/associates/getAll', callback);
  }

  http_updateAnalyticUser(user, callback) {
    return this.post(
      Globals.SERVER_ADDR + '/org/associates/update',
      user,
      callback,
    );
  }

  http_createNewAnalyticUser(user, callback) {
    return this.post(
      Globals.SERVER_ADDR + '/org/associates/add',
      user,
      callback,
    );
  }

  http_deleteAnalyticsUser(params, callback) {
    return this.post(
      Globals.SERVER_ADDR + '/org/associates/delete',
      params,
      callback,
    );
  }

  // S E C U R I T Y   G R O U P S
  http_getAllSecurityGroups(callback) {
    return this.get(
      Globals.SERVER_ADDR + '/org/securityGroups/getAll',
      callback,
    );
  }

  http_createNewSecurityGroup(group, callback) {
    return this.post(
      Globals.SERVER_ADDR + '/org/securityGroups/add',
      group,
      callback,
    );
  }

  http_updateSecurityGroup(group, callback) {
    return this.post(
      Globals.SERVER_ADDR + '/org/securityGroups/update',
      group,
      callback,
    );
  }

  http_deleteSecurityGroup(group, callback) {
    return this.post(
      Globals.SERVER_ADDR + '/org/securityGroups/delete',
      group,
      callback,
    );
  }

  // L O C A T I O N   G R O U P S
  http_getTreeInfo(item, callback) {
    return this.post(
      Globals.SERVER_ADDR + '/org/venueGroups/getTree',
      item,
      callback,
    );
  }

  http_getVenueGroups(callback) {
    return this.get(Globals.SERVER_ADDR + '/org/venueGroups/getAll', callback);
  }

  http_getVenuesForGroups(callback) {
    return this.get(
      Globals.SERVER_ADDR + '/org/venueGroups/getVenues',
      callback,
    );
  }

  http_createNewVenueGroup(venue, callback) {
    return this.post(
      Globals.SERVER_ADDR + '/org/venueGroups/add',
      venue,
      callback,
    );
  }

  http_updateVenueGroup(venue, callback) {
    return this.post(
      Globals.SERVER_ADDR + '/org/venueGroups/update',
      venue,
      callback,
    );
  }

  http_deleteVenueGroup(venue, callback) {
    return this.post(
      Globals.SERVER_ADDR + '/org/venueGroups/delete',
      venue,
      callback,
    );
  }

  // C P   C O D E S
  http_getAllCpCodes(callback) {
    return this.get(Globals.SERVER_ADDR + '/org/cpCodes/getAll', callback);
  }

  http_addCpCode(cpcode, callback) {
    return this.post(
      Globals.SERVER_ADDR + '/org/cpCodes/add',
      cpcode,
      callback,
    );
  }

  http_deleteCpCode(cpcode, callback) {
    return this.post(
      Globals.SERVER_ADDR + '/org/cpCodes/delete',
      cpcode,
      callback,
    );
  }

  http_updateCpCode(cpcode, callback) {
    return this.post(
      Globals.SERVER_ADDR + '/org/cpCodes/update',
      cpcode,
      callback,
    );
  }

  // E L E M E N T S
  http_getElements(cpLocation, callback) {
    return this.post(
      Globals.SERVER_ADDR + '/cp/elements/getElements',
      cpLocation,
      callback,
    );
  }

  http_updateElement(requestBody, callback) {
    return this.post(
      Globals.SERVER_ADDR + '/cp/elements/update',
      requestBody,
      callback,
    );
  }

  // L O C A L E S
  http_getLocalesByCpCode(cpCode, callback) {
    return this.post(
      Globals.SERVER_ADDR + '/cp/locales/byCpCode',
      cpCode,
      callback,
    );
  }

  http_getLanguages(cpLocale, callback) {
    return this.post(
      Globals.SERVER_ADDR + '/cp/locales/getLanguages',
      cpLocale,
      callback,
    );
  }

  http_getAllLocales(callback) {
    return this.get(Globals.SERVER_ADDR + '/cp/locales/getAll', callback);
  }

  http_createNewLiteral(lit, callback) {
    return this.post(Globals.SERVER_ADDR + '/cp/elements/add', lit, callback);
  }

  http_createNewLocale(locale, callback) {
    return this.post(
      Globals.SERVER_ADDR + '/cp/locales/addLocale',
      locale,
      callback,
    );
  }

  // R E P O R T S
  http_getAllActiveSessions(request, callback) {
    return this.post(
      Globals.SERVER_ADDR + '/reports/sessions/getActive',
      request,
      callback,
    );
  }

  http_getSessionStat(query, callback) {
    return this.post(
      Globals.SERVER_ADDR + '/reports/sessions/getAll',
      query,
      callback,
    );
  }

  http_getLoginHistory(callback) {
    return this.get(
      Globals.SERVER_ADDR + '/reports/loginHistory/getAll',
      callback,
    );
  }

  http_getChanges(callback) {
    return this.get(
      Globals.SERVER_ADDR + '/reports/changeLog/getAll',
      callback,
    );
  }

  http_getActivityReport(
    username: string,
    start: string,
    end: string,
    callback,
  ) {
    const params = new HttpParams()
      .set('userName', username)
      .set('start', start)
      .set('end', end);
    return this.getWithParams(
      Globals.SERVER_ADDR + '/reports/changeLog/userActivities',
      params,
      callback,
    );
  }

  http_getSummaryReportTimeOpts(callback) {
    return this.get(
      Globals.SERVER_ADDR + '/reporting/smsAccounting/summary/timeWindows',
      callback
    );
  }

  http_getSummaryReportWeeks(callback) {
    return this.get(
      Globals.SERVER_ADDR + '/reporting/smsAccounting/summary/getWeeks',
      callback
    );
  }

  http_getSummaryReportMonth(callback) {
    return this.get(
      Globals.SERVER_ADDR + '/reporting/smsAccounting/summary/getMonths',
      callback
    );
  }

  http_getSummaryReportDays(month, callback) {
    return this.post(
      Globals.SERVER_ADDR + '/reporting/smsAccounting/summary/getDaysForMonth',
      month,
      callback
    );
  }

  http_getSummaryReport(params, callback) {
    return this.get(
      Globals.SERVER_ADDR + '/reporting/smsAccounting/summary/get' + params,
      callback
    );
  }

  http_getRedirectOptions(callback) {
    return this.get(Globals.SERVER_ADDR + '/cp/redirectOptions', callback);
  }

  http_getTimeWindows(callback) {
    return this.get(Globals.SERVER_ADDR + '/dashboard/timeWindows', callback);
  }

  http_getMonths(callback) {
    return this.get(Globals.SERVER_ADDR + '/dashboard/getMonths', callback);
  }

  http_getWeeks(callback) {
    return this.get(Globals.SERVER_ADDR + '/dashboard/getWeeks', callback);
  }

  http_getHours(callback) {
    return this.get(Globals.SERVER_ADDR + '/dashboard/getHours', callback);
  }

  http_getDaysForMonth(params, callback) {
    return this.post(
      Globals.SERVER_ADDR + '/dashboard/getDaysForMonth',
      params,
      callback,
    );
  }

  http_getSentMessages(callback) {
    return this.get(Globals.SERVER_ADDR + '/reports/sentMessages/getAll', callback);
  }

  // R E D I R E C T   C H A N G E S
  http_getRedirectStrategies(callback) {
    return this.get(
      Globals.SERVER_ADDR + '/cp/redirectStrategies/getStrategies',
      callback,
    );
  }

  http_getStrategyPeriodOfDay(callback) {
    return this.get(
      Globals.SERVER_ADDR + '/cp/redirectStrategies/menu/periodOfDay',
      callback,
    );
  }

  http_getStrategyDayOfWeek(callback) {
    return this.get(
      Globals.SERVER_ADDR + '/cp/redirectStrategies/menu/dayOfWeek',
      callback,
    );
  }

  http_getStrategyDeviceType(callback) {
    return this.get(
      Globals.SERVER_ADDR + '/cp/redirectStrategies/menu/deviceType',
      callback,
    );
  }

  http_getStrategyRules(rule, callback) {
    return this.get(
      Globals.SERVER_ADDR +
        '/cp/redirectStrategies/getRules?strategyId=' +
        rule,
      callback,
    );
  }

  http_addRedirectStrategy(strategy, callback) {
    return this.post(
      Globals.SERVER_ADDR + '/cp/redirectStrategies/add',
      strategy,
      callback,
    );
  }

  http_removeRedirectStrategy(strategy, callback) {
    return this.post(
      Globals.SERVER_ADDR + '/cp/redirectStrategies/delete',
      strategy,
      callback,
    );
  }

  http_updateRedirectStrategy(strategy, callback) {
    return this.post(
      Globals.SERVER_ADDR + '/cp/redirectStrategies/update',
      strategy,
      callback,
    );
  }

  http_addStrategyRule(rule, callback) {
    return this.post(
      Globals.SERVER_ADDR + '/cp/redirectStrategies/addRule',
      rule,
      callback,
    );
  }

  http_removeStrategyRule(rule, callback) {
    return this.post(
      Globals.SERVER_ADDR + '/cp/redirectStrategies/deleteRule',
      rule,
      callback,
    );
  }

  http_updateStrategyRule(rule, callback) {
    return this.post(
      Globals.SERVER_ADDR + '/cp/redirectStrategies/updateRule',
      rule,
      callback,
    );
  }

  // M E S S A G I N G   S T R A T E G I E S
  http_getMessagingStrategies(callback) {
    return this.get(
      Globals.SERVER_ADDR + '/cp/messagingStrategies/getStrategies',
      callback,
    );
  }

  http_getMessagingStrategyPeriodOfDay(callback) {
    return this.get(
      Globals.SERVER_ADDR + '/cp/messagingStrategies/menu/periodOfDay',
      callback,
    );
  }

  http_getMessagingStrategyDayOfWeek(callback) {
    return this.get(
      Globals.SERVER_ADDR + '/cp/messagingStrategies/menu/dayOfWeek',
      callback,
    );
  }

  http_getMessagingStrategyDeviceType(callback) {
    return this.get(
      Globals.SERVER_ADDR + '/cp/messagingStrategies/menu/deviceType',
      callback,
    );
  }

  http_getMessagingStrategyRules(rule, callback) {
    return this.get(
      Globals.SERVER_ADDR +
        '/cp/messagingStrategies/getRules?strategyId=' +
        rule,
      callback,
    );
  }

  http_addMessagingStrategy(strategy, callback) {
    return this.post(
      Globals.SERVER_ADDR + '/cp/messagingStrategies/add',
      strategy,
      callback,
    );
  }

  http_removeMessagingStrategy(strategy, callback) {
    return this.post(
      Globals.SERVER_ADDR + '/cp/messagingStrategies/delete',
      strategy,
      callback,
    );
  }

  http_updateMessagingStrategy(strategy, callback) {
    return this.post(
      Globals.SERVER_ADDR + '/cp/messagingStrategies/update',
      strategy,
      callback,
    );
  }

  http_addMessagingStrategyRule(rule, callback) {
    return this.post(
      Globals.SERVER_ADDR + '/cp/messagingStrategies/addRule',
      rule,
      callback,
    );
  }

  http_removeMessagingStrategyRule(rule, callback) {
    return this.post(
      Globals.SERVER_ADDR + '/cp/messagingStrategies/deleteRule',
      rule,
      callback,
    );
  }

  http_updateMessagingStrategyRule(rule, callback) {
    return this.post(
      Globals.SERVER_ADDR + '/cp/messagingStrategies/updateRule',
      rule,
      callback,
    );
  }

  // T I M E   Z O N E S
  http_getTimeZones(callback) {
    return this.get(Globals.SERVER_ADDR + '/org/locations/timeZones', callback);
  }

  // N O T   L O G G E D   I N   U S E R S
  http_getNotLoggedInUsers(nasid: string, start, end, callback) {
    const params = new HttpParams()
      .set('nasid', nasid)
      .set('start', start)
      .set('end', end);
    return this.getWithParams(
      Globals.SERVER_ADDR + '/reports/sessions/usersNotLoggedIn',
      params,
      callback,
    );
  }

  http_updateLocaleFromFile(formData: FormData, callback) {
    return this.post(
      Globals.SERVER_ADDR + '/cp/locales/loadFromXLS',
      formData,
      callback,
    );
  }

  http_getMailchimpLists(accId, callback) {
    const params = new HttpParams().set('accId', accId);
    return this.getWithParams(
      Globals.SERVER_ADDR + '/accounts/mailchimp/getMailchimpList',
      params,
      callback,
    );
  }

  http_getMailchimpGroups(accId, listId, callback) {
    const params = new HttpParams().set('accId', accId).set('listId', listId);
    return this.getWithParams(
      Globals.SERVER_ADDR + '/accounts/mailchimp/getMailchimpGroups',
      params,
      callback,
    );
  }

  http_getMailchimpGroupCategories(accId, listId, categoryId, callback) {
    const params = new HttpParams()
      .set('accId', accId)
      .set('listId', listId)
      .set('categoryId', categoryId);
    return this.getWithParams(
      Globals.SERVER_ADDR + '/accounts/mailchimp/getMailchimpGroupCategories',
      params,
      callback,
    );
  }

  // S M S   A C C O U N T I N G
  http_getNasidsForSMS(callback) {
    return this.get(
      Globals.SERVER_ADDR + '/reporting/smsAccounting/nasidsDropdown',
      callback,
    );
  }

  http_getCountriesForSMS(callback) {
    return this.get(
      Globals.SERVER_ADDR + '/reporting/smsAccounting/countriesDropdown',
      callback,
    );
  }

  http_getAllSMS(callback) {
    return this.get(
      Globals.SERVER_ADDR + '/reporting/smsAccounting/getAll',
      callback,
    );
  }

  http_getAllSMSByCountry(country, callback) {
    const params = new HttpParams().set('country', country);
    return this.getWithParams(
      Globals.SERVER_ADDR + '/reporting/smsAccounting/getByCountry',
      params,
      callback,
    );
  }

  http_getAllSMSByNasId(nasid, callback) {
    const params = new HttpParams().set('nasid', nasid);
    return this.getWithParams(
      Globals.SERVER_ADDR + '/reporting/smsAccounting/getByNasid',
      params,
      callback,
    );
  }

  http_getAllSMSByPeriod(from, to, callback) {
    const params = new HttpParams().set('from', from).set('to', to);
    return this.getWithParams(
      Globals.SERVER_ADDR + '/reporting/smsAccounting/getForPeriod',
      params,
      callback,
    );
  }

  // F O R G E T   U S E R
  http_forgetUserByMac(mac, callback) {
    const params = new HttpParams().set('mac', mac);
    return this.postWithParams(
      Globals.SERVER_ADDR + '/admin/forget/byMac',
      null,
      params,
      callback,
    );
  }

  http_forgetUserByUsername(username, callback) {
    const params = new HttpParams().set('username', username);
    return this.postWithParams(
      Globals.SERVER_ADDR + '/admin/forget/byUsername',
      null,
      params,
      callback,
    );
  }

  // D Y N A M I C   I M A G E S
  http_getDynamicImages(templateId, callback) {
    const params = new HttpParams().set('templateId', templateId);
    return this.getWithParams(
      Globals.SERVER_ADDR + '/cp/dynamicImages/getRules',
      params,
      callback,
    );
  }

  http_getImageInfo(ruleId, viewId, tag, callback) {
    const params = new HttpParams()
      .set('ruleId', ruleId)
      .set('viewId', viewId)
      .set('tag', tag);
    return this.getWithParams(
      Globals.SERVER_ADDR + '/cp/dynamicImages/findImage',
      params,
      callback,
    );
  }

  http_removeImage(id, callback) {
    return this.post(
      Globals.SERVER_ADDR + '/cp/dynamicImages/deleteImage',
      id,
      callback,
    );
  }

  http_uploadDynamicImage(ruleId, viewId, tag, file, callback) {
    const params = new HttpParams()
      .set('ruleId', ruleId)
      .set('viewId', viewId)
      .set('tag', tag)
      .set('file', file);

    return this.postWithParams(
      Globals.SERVER_ADDR + '/cp/dynamicImages/updateImage',
      null,
      params,
      callback,
    );
  }

  http_dynamicImageAddRule(rule, callback) {
    return this.post(
      Globals.SERVER_ADDR + '/cp/dynamicImages/addRule',
      rule,
      callback,
    );
  }

  http_dynamicImageUpdateRule(rule, callback) {
    return this.post(
      Globals.SERVER_ADDR + '/cp/dynamicImages/updateRule',
      rule,
      callback,
    );
  }

  http_dynamicImageDeleteRule(id, callback) {
    return this.post(
      Globals.SERVER_ADDR + '/cp/dynamicImages/deleteRule',
      id,
      callback,
    );
  }

  http_getImagesCountries(callback) {
    return this.get(Globals.SERVER_ADDR + '/cp/img/getCountries', callback);
  }

  http_uploadImage(cpIdentifier, tag, file, callback) {
    const formdata: FormData = new FormData();
    formdata.append('file', file);

    const params = new HttpParams()
      .set('cpIdentifier', cpIdentifier)
      .set('tag', tag)
      .set('file', JSON.stringify(formdata));

    const req = new HttpRequest(
      'POST',
      Globals.SERVER_ADDR + '/cp/img/updateCreate',
      formdata,
      {
        reportProgress: true,
        params: params,
        responseType: 'text',
        headers: this.getHeaders(),
      },
    );

    return this.request(req, callback);
  }

}



// WEBPACK FOOTER //
// /home/sgurin/IdeaProjects/cosy/cp-builder/src/app/superclass/SuperClass.ts